import { ModuleRouteConfig, RouteRegistry } from "../types";
import { homeRoutes, baseRoute as homeBaseRoute } from "./homeRoutes";
import { inventoryRoutes, baseRoute as inventoryRoute } from "./inventoryRoutes";
import { samplesRoutes, baseRoute as samplesRoute } from "./samplesRoutes";
import { testsRoutes, baseRoute as testsRoute } from "./testsRoutes";
import {
  analyticalServicesRoutes,
  baseRoute as analyticalServicesRoute,
} from "./analyticalServicesRoutes";
import { sQCRoutes, baseRoute as sQCRoute } from "./sqcRoutes";
import { requestsRoutes, baseRoute as requestsRoute } from "./requestsRoutes";
import { blendsRoutes, baseRoute as blendsRoute } from "./blendsRoutes";
import { distillationsRoutes, baseRoute as distillationsRoute } from "./distillationsRoutes";
import { stockroomRoutes, baseRoute as stockroomRoute } from "./stockroomRoutes";
import { utilitiesRoutes, baseRoute as utilitiesRoute } from "./utilitiesRoutes";
import { adminRoutes, baseRoute as adminRoute } from "./adminRoutes";
//import { bookmarksRoutes, baseRoute as bookmarksRoute } from "./bookmarksRoutes";
import {
  stationaryTestingRoutes,
  baseRoute as stationaryTestingRoute,
} from "./stationaryTestingRoutes";
import { statusPageRoutes } from "./statusPageRoutes";
import { userServicesRoutes } from "./userServicesRoutes";
import { sortRoutesBySpecificity } from "./registryHelpers";

export const routeRegistry: RouteRegistry = sortRoutesBySpecificity({
  ...homeRoutes,
  ...inventoryRoutes,
  ...samplesRoutes,
  ...testsRoutes,
  ...analyticalServicesRoutes,
  ...sQCRoutes,
  ...requestsRoutes,
  ...blendsRoutes,
  ...distillationsRoutes,
  ...stationaryTestingRoutes,
  ...stockroomRoutes,
  ...utilitiesRoutes,
  ...adminRoutes,
  //...bookmarksRoutes,
  ...userServicesRoutes,
  ...statusPageRoutes,
});

export const moduleRoutes: ModuleRouteConfig[] = [
  homeBaseRoute,
  inventoryRoute,
  samplesRoute,
  testsRoute,
  analyticalServicesRoute,
  sQCRoute,
  requestsRoute,
  blendsRoute,
  distillationsRoute,
  stationaryTestingRoute,
  stockroomRoute,
  utilitiesRoute,
  adminRoute,
  //bookmarksRoute,
];

/*
Todo: an additional consideration is that in production, we dont want to give full access to dev roles, right?
*/
